import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IProductCentreDocumentDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { IExistingSlotItem } from '@app/views/products/tabs/product-centre/product-centre-tab.component';

@Component({
    selector: 'cb-product-centre-find-dialog',
    templateUrl: './product-centre-find-dialog.component.html',
    styleUrls: ['./product-centre-find-dialog.component.scss'],
    standalone: false
})
export class ProductCentreFindDialogComponent {
    public static readonly MIN_WIDTH = '95%';

    constructor(
        public readonly dialogRef: MatDialogRef<ProductCentreFindDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public readonly data: {
            activeOnly: boolean;
            initializeSearchOnLoad: boolean;
            categoryIdFilter: number;
            businessEntityIdsToFilterBy: Set<number>;
            businessEntityIdsToSortBy: Set<number>;
            restrictedBusinessEntityIds: Set<number>;
            existingSlotItem: IExistingSlotItem;
            hideNationalRate: boolean;
            showCurrentProduct: boolean;
            currentProductTitle: string;
            ignoreTierBasedSorting: boolean;
        }
    ) {}

    public productSelected(dto: IProductCentreDocumentDto): void {
        this.dialogRef.close(dto);
    }

    public close(): void {
        this.dialogRef.close(false);
    }
}
